





























































































import {Component, Vue, Watch} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import {ProductEntity} from "@/entity/ProductEntity";
import LetEditable from "@/components/LetEditable.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import Select35 from "@/components/inputs/Select35.vue";
import {categories} from "@/entity/CategoryEntity";
import SearchForm from "@/components/forms/SearchForm.vue";
import SearchFields, {FieldSelect, SearchFieldType} from "@/entity/SearchEntity";
import CopyButton from "@/components/datatable/CopyButton.vue";
import CategoryCopyButton from "@/components/CategoryCopyButton.vue";
import {fonts} from "@/entity/FontsEntity";

class productsResponse {
    data !: ProductEntity[];
    count!:number;
    pageCount!:number;
    currentPage!:number;
    offset!:number;
}

@Component({
    components: {
        CategoryCopyButton,
        CopyButton,
        DeleteButton,EForm,Number,TextField,Id,LetEditable,EnabledSwitch,Select35,SearchForm
    }
})
export default class Product extends  Vue{
    fontlar:fonts[] = [];
    selectedItems : number[]  = [];
    categories : categories[] = [];
    fieldSelect :FieldSelect = new FieldSelect();
    searchFields : SearchFields[] = [new SearchFields()];
    searchRequestData:[] = [];
    items : ProductEntity[] | null = null;
    page = 1;
    pageCount = 1;
    dense =  true;
    fixedHeader = true;
    height = 500;
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = "product";
    action:string = this.baseAction;
    data : ProductEntity = new ProductEntity();
    lastPage = 0;
    limitItems:number[] = [10,25,50,100,250];
    limit:number = 50;
    checkbox:boolean=false;
    showDeleted:boolean=false;
    delay = (function(){
        let timer:any;
        return function(callback:any, ms:any){
            clearTimeout (timer);
            timer = setTimeout(callback, ms);
        };
    })();

    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "product_id"
        },
        {text: "Ürün", value: "image_show_thumb"},
        {text: "Başlık", value: "name"},
        //{text: "Açıklama", value: "description"},
        {text: "Kategori", value: "cat_id"},
        {text: "Stok kodu", value: "stock_code"},
        {text: "Ürün tipi", value: "product_type_id"},
        {text: "Aktif", value: "enabled"},
        {text: "İşlemler", value: "actions"}
    ];
    deneme(e : Event){
        console.log(e);
    }
    selectAll(){
        console.log("tselectall");
        if(this.checkbox === true){
            this.items?.forEach((item:ProductEntity)=>{
                this.selectedItems.push(item.product_id);
            })
        }else{
            this.selectedItems = [];
        }
    }
    checkSelectedRow(product_id:number):boolean{
        var d = this.selectedItems.find(x=>x == product_id);
        if(d){
            return true;
        }
        return  false;
    }
    selectRow(product_id:number){
        let exists = this.checkSelectedRow(product_id);
        if(exists == true){
            this.selectedItems.splice(this.selectedItems.indexOf(product_id),1);
        }else{
            this.selectedItems.push(product_id);
        }
    }
    changePage(page:number){
        this.get(page);
    }
    edit(item:ProductEntity){
        //Burasi dmde urunler
        //Digerlerinde urun
        this.$store.dispatch("go","urun"+"/"+item.product_id);
    }
    newTab(item:ProductEntity){
        window.open("urun"+"/"+item.product_id,"_blank");
    }
    add(){
        this.$store.dispatch("go","urun/ekle");
    }
    detailSearch(searchRequestData:any){
        this.searchRequestData = searchRequestData;
        this.lastPage = -1;
        this.get(1);
    }
    deleted(){
        this.lastPage = -1;
        this.get(this.page);
    }
    async get(page:number = 1,created = false){
        //console.log("GET",this.lastPage,this.page);
        if(this.lastPage == this.page){
            return ;
        }
        this.items = null;
        let params = "?page="+page;
        if(this.search != ""){
            params += "&q="+this.search;
        }
        params += "&limit="+this.limit;
        if(this.showDeleted == true){
            params += "&deleted=1";
        }
        let productTable = {
            page:page,
            showDeleted:this.showDeleted,
            limit:this.limit,
            search:this.search
        }
        localStorage.setItem("productTable",JSON.stringify(productTable));
        this.dialog = false;
        //let response = await this.$http.post("productSearch?page="+page+params,JSON.stringify(this.searchRequestData));
        let response = await Vue.prototype.$http.request({
            method:"POST",
            responseType:"json",
            data:JSON.stringify(this.searchRequestData),
            transformRequest:[function (data:any, headers:any) {
                return data;
            }],
            url:"productSearch"+params
        });
        this.items = response.data.data;
        this.pageCount = response.data.pageCount;
        this.lastPage = this.page;
        //this.page = response.data.currentPage;
    }
    limitChange(){
        localStorage.setItem("tablelimit",String(this.limit));
        this.lastPage = -1;
        this.get(this.page);
    }
    copied(sccdata:any){
        this.lastPage = -1;
        this.get(1);
        this.page = 1;
    }

    searchItems(){
        this.searchRequestData = [];
        this.delay(()=> {
            this.lastPage = -1;
            this.get(1);
            this.page = 1;
        },300)
    }

    async getCategories(){
        let response = await this.$http.get("categories/endOfTreeList");
        this.categories = response.data;
        console.log("getCategories");
        await this.fillSearchFields();
    }
    created(){
        let limit = localStorage.getItem("tablelimit");
        if( limit != null){
            this.limit = parseInt(limit);
        }
        let productTable : any = localStorage.getItem("productTable");
        if(productTable){
            productTable  = JSON.parse(productTable);
            this.page = productTable.page;
            this.showDeleted = productTable.showDeleted;
            this.limit = productTable.limit;
            this.search = productTable.search;
        }
        this.get(this.page);
        this.getCategories();
    }
    async fillSearchFields(){
        let fieldSelect = new FieldSelect();
        fieldSelect.items = this.categories;
        fieldSelect.itemValue = "cat_id";
        fieldSelect.itemText = "title";

        this.searchFields = [
          {
            type:SearchFieldType.ReverseBoolean,
            data: [],
            name:"enabled",
            label:"Pasif Ürünler",
            operator:"=",
            value:"",
            value2:"",
            active:true
          },
          {
            type:SearchFieldType.Text,
            data: [],
            name:"product_id",
            label:"ID büyüktür",
            operator:">",
            value:"",
            value2:"",
            active:true
          },
          {
            type:SearchFieldType.Text,
            data: [],
            name:"product_id",
            label:"ID eşittir",
            operator:"=",
            value:"",
            value2:"",
            active:true
          },
          {
            type:SearchFieldType.Text,
            data: [],
            name:"product_id",
            label:"ID küçüktür",
            operator:"<",
            value:"",
            value2:"",
            active:true
          },{
            type:SearchFieldType.Date,
            data: [],
            name:"created_at",
            label:"Oluşturulma Tarihi Eşittir",
            operator:"=",
            value:"",
            value2:"",
            active:true
          },
          {
            type:SearchFieldType.DateBetween,
            data: [],
            name:"created_at",
            label:"Oluşturulma Tarihi",
            operator:"",
            value:"",
            value2:"",
            active:true
          },{
            type:SearchFieldType.Date,
            data: [],
            name:"updated_at",
            label:"Düzenleme Tarihi Eşittir",
            operator:"=",
            value:"",
            value2:"",
            active:true
          },
          {
            type:SearchFieldType.DateBetween,
            data: [],
            name:"updated_at",
            label:"Düzenleme Tarihi",
            operator:"",
            value:"",
            value2:"",
            active:true
          }
        ];
        console.log("this.searchFields",this.searchFields);
    }
};
